export const yearsAgoCreator = (yearsAgoLimit) => {
  let yearsAgo = new Date();
  yearsAgo = yearsAgo.setFullYear(
    yearsAgo.getFullYear() - yearsAgoLimit
  );
  return yearsAgo;
};